import React from 'react'
import Button from 'components/button/Button'
import SFXS from '../../../assets/audios/audios'

interface SET_PROPS {
  setStake: any
  audio?: any
  isOperation?: boolean
  colors: any
}
export default function Set({ setStake, audio, colors }: SET_PROPS) {
  return (
    <Button
      width='311px'
      func={setStake}
      audio={audio}
      SFX={SFXS.confirmSFX}
      textColor={colors.tertiaryDark}
      background={colors.secondaryDark}
    >
      SET
    </Button>
  )
}
